import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { RESUME } from "./data";
import { EASE, Reveal } from "./Reveal";

const STEPS = [
  { n: "01", name: "Research", detail: "4–6 hrs → minutes" },
  { n: "02", name: "Judge", detail: "65% → 98% accuracy" },
  { n: "03", name: "Publish", detail: "10k+ URLs / day" },
];

export function CaseStudy() {
  return (
    <section className="case-study page-width" data-testid="featured-case-study">
      <div className="case-label">
        <span className="section-kicker">Featured build</span>
        <span className="case-index">01 / 03</span>
      </div>
      <div className="case-grid">
        <Reveal>
          <h2>
            Making AI useful
            <br />
            <span>at operating speed.</span>
          </h2>
          <p className="case-copy">
            At Consumable AI, I built the product and the systems behind an AI-powered SEO/AEO
            platform — from agentic research to async crawling to one-click publishing.
          </p>
          <a href={RESUME} target="_blank" rel="noreferrer" className="text-link underline-link" data-testid="case-study-resume-link">
            Read the full story <ArrowUpRight size={16} />
          </a>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="case-console">
            <div className="console-header">
              <span>consumable_ai / pipeline</span>
              <span>production</span>
            </div>
            <div className="case-progress" data-testid="case-progress-bar">
              <motion.div
                className="case-progress-fill"
                initial={{ width: "3%" }}
                whileInView={{ width: "98%" }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 1.8, delay: 0.4, ease: EASE }}
              />
            </div>
            <div className="pipeline">
              {STEPS.map((step, i) => (
                <div key={step.n} className="pipeline-step-wrap">
                  <motion.div
                    className="pipeline-step"
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.6, delay: 0.3 + i * 0.22, ease: EASE }}
                  >
                    <b>{step.n}</b>
                    <span>{step.name}</span>
                    <small>{step.detail}</small>
                  </motion.div>
                  {i < STEPS.length - 1 && <i className="pipeline-arrow">→</i>}
                </div>
              ))}
            </div>
            <div className="console-footer">
              <span className="status-dot" /> agents are running <strong>●</strong>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
